import React, { useEffect, useState } from 'react';
import api from '../../../api';

function OrderStatus({ id }) {
  const [loading, setLoading] = useState(true);
  const [order, setOrder] = useState({ payment: {} });

  const getStatus = async () => {
    const order = await api.checkOrderStatus(id);
    setOrder(order);
    console.log(order);

    // sprawdzaj co sekunde
    if (order.status === 'started') {
      setTimeout(() => getStatus(), 1000);
    } else {
      setLoading(false)
    }
  }

  useEffect(() => {
    getStatus()
  }, []);

  return (
  <>
    {order.status === 'started' && <h2 class="card_title">Twoja rezerwacja jest przetwarzana</h2>}
    {order.status === 'completed' && <h2 class="card_title">Twoja rezerwacja została przyjęta!</h2>}
    {order.status === 'rejected' && <h2 class="card_title">Twoja rezerwacja została odrzucona</h2>}
    
    <h5 className="card_title">Status płatności: &nbsp;
      {order.payment.channelId === 1 && <div class="badge bg-secondary">płatność gotówką</div>}
      {order.payment.channelId === 2 && order.payment.status === 'started' && <div className="badge bg-info">przetwarzana</div>}
      {order.payment.channelId === 2 && order.payment.status === 'completed' && <div className="badge bg-success">zaksięgowana</div>}
      {order.payment.channelId === 2 && order.payment.status === 'rejected' && <div className="badge bg-danger">odrzucona</div>}
    </h5>

    {loading && (
      <div>
        <p>Właśnie przetwarzamy Twoją rezerwację {order.payment.channelId === 2 && 'i płatność'}. Jeśli chcesz, możesz opuścić tą stronę. Potwierdzenie zostanie wysłane na adres e-mail, gdy skończymy.</p>
        <div className="d-flex justify-content-center" style={{ marginTop: 20 }}>
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Przetwarzanie...</span>
          </div>
        </div>
      </div>
    )}

    {order.status === 'completed' && (
    <>
      <div className="alert alert-success">
          Wszystko gotowe, potwierdzenie rezerwacji zostanie wysłane w ciągu kilku minut! Sprawdź swoja skrzynkę e-mail.
      </div>
      <p><i>Jeśli po 10 minutach wciąż nie widzisz wiadomości, <b>sprawdź w zakładce "Oferty" lub spam</b>.</i></p>
    </>
    )}

  </>);
}

export default OrderStatus;